import type { Products } from "../types"

export const products: Products = new Map([])
